export default __webpack_public_path__ + "static/media/gym-video.5440af78.mp4";